<template>
    <div id="alfrescoShareBrowser">

        <main role="main">

            <div class="container">

                <div class="row mb-5">
                    <div class="col-md-4">

                        <div class="card">
                            <div class="card-body overflow-auto bg-light" style="max-height: 80vh;">
                                <div v-for="(item, index) in nodes" :key="item.entry.id" v-if="item.entry.isFolder">
                                    <FileBrowserMenuItem :node="item" :ref="'node_' + item.entry.id"
                                                         :key="'node_' + item.entry.id"
                                                         v-if="item.entry.isFolder"></FileBrowserMenuItem>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-8">

                        <div class="card">
                            <div class="card-body overflow-auto p-0">

                                <div v-if="activeNodeContent">
                                    <div class="d-block p-2 border-bottom listItem"
                                         v-for="(item, index) in activeNodeContent.list.entries"
                                         :key="'list' + item.entry.id"
                                         v-if="item.entry.isFolder || item.entry.isFile"
                                         @click="onNodeItemClick(item)">
                                        <div class="preview float-left mr-2">
                                            <ThumbnailImage :node="item.entry" :key="'thumbnail' + item.entry.id"
                                                            v-if="item.entry"/>
                                        </div>
                                        <div class="details">
                                            <h5 class="text-break" style="font-size: 1.1em">{{item.entry.name}}</h5>
                                            <div style="font-size: 0.9em">
                                                <div class="description" v-if="item.entry.properties">
                                                    <span v-if="item.entry.properties['cm:description']">{{item.entry.properties['cm:description']}}</span>
                                                    <em v-if="!item.entry.properties['cm:description']" class="text-muted">/</em>
                                                </div>
                                                <div v-if="!item.entry.properties">
                                                    <em class="text-muted">/</em>
                                                </div>
                                                <div>
                                                    <div class="lastChange float-left"><small class="text-muted">zadnja sprememba:</small>
                                                        {{moment(item.entry.modifiedAt).local().format('DD. MM. YYYY HH:mm:ss')}}
                                                    </div>
                                                    <div class="size float-left ml-4" v-if="item.entry.content"><small
                                                            class="text-muted">velikost:</small>
                                                        {{item.entry.content.sizeInBytes | prettyBytes}}
                                                    </div>
                                                </div>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>

                                    <div class="row"
                                         v-if="activeNodeContent && activeNodeContent.list.pagination.totalItems > serverParams.perPage">
                                        <div class="col-md-12 pt-3 bg-light">
                                            <b-pagination
                                                    class="list-inline mx-auto justify-content-center"
                                                    v-model="serverParams.page"
                                                    :total-rows="activeNodeContent.list.pagination.totalItems"
                                                    :per-page="serverParams.perPage"
                                                    limit="10"
                                                    @change="onPageChange"
                                            >
                                                <template v-slot:first-text><span><i
                                                        class="fas fa-fast-backward"></i></span></template>
                                                <template v-slot:prev-text><span><i
                                                        class="fas fa-step-backward"></i></span></template>
                                                <template v-slot:next-text><span><i
                                                        class="fas fa-step-forward"></i></span></template>
                                                <template v-slot:last-text><span><i
                                                        class="fas fa-fast-forward"></i></span></template>
                                            </b-pagination>
                                        </div>
                                    </div>

                                </div>
                                <div v-if="activeNodeContent === null || activeNodeContent.list.entries.length === 0">
                                    <div class="text-center m-3 alert alert-secondary">
                                        <small class="muted">Ni vsebine za prikaz</small>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>


        <b-modal ref="node-details-modal" :title="clickedNode ? clickedNode.name : ''" size="xl">

            <div class="row">
                <div class="col-md-12 mb-0">
                    <NodeDetails
                            v-if="clickedNode"
                            ref="node-details"
                            :node="clickedNode"
                    ></NodeDetails>
                </div>
            </div>


            <div slot="modal-footer" class="w-100">
                <b-button
                        id="headerCloseModalButton1"
                        variant="primary"
                        class="float-right"
                        @click="closeModal">
                    {{$t('text.globals.ok')}}
                </b-button>
            </div>

        </b-modal>

    </div>
</template>

<script>
    import axios from "axios";
    import FileBrowserMenuItem from "../components/FileBrowserMenuItem";
    import ThumbnailImage from "../components/ThumbnailImage";
    import NodeDetails from "../components/NodeDetails";


    export default {
        name: "AlfrescoShareBrowser",
        components: {
            FileBrowserMenuItem,
            ThumbnailImage,
            NodeDetails
        },
        data() {
            return {
                rootId: null,
                nodes: [],
                clickedNode: null,
                activeNodeContent: null,
                serverParams: {
                    page: 1,
                    perPage: 45
                },
            }
        },

        mounted() {
            const _this = this;

            _this.getRoot();
        },

        computed: {
            getActiveNode() {
                const _this = this;
                _this.serverParams.page = 1;
                return _this.$store.getters.getActiveNode;
            }
        },

        watch: {
            getActiveNode: function () {
                const _this = this;
                _this.getActiveNodeContent();
            }
        },

        methods: {
            getRoot() {
                const _this = this;

                axios.get(config.alfrescoCoreApi + 'nodes/-root-')
                    .then((res) => {

                        _this.rootId = res.data.entry.id;
                        _this.$store.dispatch('setActiveNode', res.data.entry);
                        _this.getChildrenNodes(res.data.entry.id);
                    })
                    .catch((error) => {
                        console.error(error);
                    });

            },
            getChildrenNodes(parentId) {
                const _this = this;

                axios.get(config.alfrescoCoreApi + 'nodes/' + parentId + '/children?where=(isFolder%3Dtrue)&maxItems=1000')
                    .then((res) => {

                        _this.nodes = res.data.list.entries;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },

            getActiveNodeContent() {
                const _this = this;

                axios.get(config.alfrescoCoreApi + 'nodes/' + _this.$store.getters.getActiveNode.id + '/children', {
                    params: {
                        skipCount: (_this.serverParams.page - 1) * _this.serverParams.perPage,
                        maxItems: _this.serverParams.perPage,
                        include: 'properties'
                    }
                })
                    .then((res) => {
                        _this.activeNodeContent = res.data;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },

            onNodeItemClick(item) {
                const _this = this;

                console.log("onNodeItemClick", item);
                if (item.entry.isFolder) {
                    _this.$store.dispatch('setActiveNode', item.entry);
                } else {
                    _this.clickedNode = item.entry;
                    _this.$refs['node-details-modal'].show();
                    setTimeout(function () {
                        _this.$refs['node-details'].getNode(item.entry.id);
                    }, 200);

                }
            },

            onPageChange(params) {
                const _this = this;

                _this.isLoading = true;
                _this.serverParams.page = params;

                setTimeout(function () {
                    _this.getActiveNodeContent();
                }, 1)

            },

            closeModal() {
                const _this = this;
                _this.$refs['node-details-modal'].hide();

                setTimeout(function () {
                    _this.clickedNode = null;
                }, 200);


            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/AlfrescoShareBrowser.vue